<div class="app flex-row align-items-center">
  
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-6 card ra-card ra-content-center">
        
        <alert type="danger" *ngIf="error" [dismissible]="true">
          <p class="text-center"><strong>Oh snap!</strong> {{this.errorMessage}}</p>
        </alert>

        <div class="text-center">
          <h1><b>Accès non autorisé !</b></h1>
          <p class="text-muted">Vous devez vous connecter et avoir les priviléges nécessaires pour pouvoir accéder à cette page.</p>
          <br>
        </div>
 
        <div routerLink="/login" class="ra-button ra-button-primary">Retour à la connexion</div>
      </div>
    </div>
  </div>
</div>